import { render, staticRenderFns } from "./LibrosHygge.vue?vue&type=template&id=46446c14&scoped=true&"
import script from "./LibrosHygge.vue?vue&type=script&lang=js&"
export * from "./LibrosHygge.vue?vue&type=script&lang=js&"
import style0 from "./LibrosHygge.vue?vue&type=style&index=0&id=46446c14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46446c14",
  null
  
)

export default component.exports